// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Fun from "melange/fun.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function activate(send, action, param) {
  Curry._1(send, /* Close_menu */ 15);
  Curry._1(send, action);
}

function entry(send, text, action) {
  const partial_arg = (function (param) {
    return activate(send, action, param);
  });
  const partial_arg$1 = text;
  return function (param, param$1) {
    return Lui_elements.menu_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
}

function trigger(send, source, id, label, title) {
  const partial_arg = "chevron_down";
  const partial_arg$1 = 14;
  const partial_arg$2 = 14;
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = "hidden";
      const partial_arg$1 = "ellipsis";
      const partial_arg$2 = "nowrap";
      const partial_arg$3 = "start";
      const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(title, source)));
      const partial_arg$5 = "sidebar-context";
      const partial_arg$6 = 0;
      const partial_arg$7 = 1;
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.icon(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$3 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$4 = {
    TAG: /* Open_menu */ 50,
    _0: id
  };
  const partial_arg$5 = (function (param) {
    return Lui_elements.press(send, partial_arg$4, param);
  });
  const partial_arg$6 = label;
  const partial_arg$7 = "ghost";
  const partial_arg$8 = 0;
  const partial_arg$9 = 1;
  const partial_arg$10 = "start";
  return function (param, param$1) {
    return Lui_elements.button(undefined, undefined, partial_arg$10, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, param, param$1);
  };
}

function workspace_title(m) {
  const w = Stdlib__List.find_opt((function (w) {
    return Caml_obj.caml_equal(w.id, Mapre_web__Web_types.workspace(m.route));
  }), m.workspaces);
  if (w !== undefined) {
    return w.name;
  } else {
    return "Mapre";
  }
}

function identity(source) {
  const partial_arg = Signal.map((function (m) {
    return Stdlib__Option.to_list(m.current_user);
  }), source);
  return function (param, param$1) {
    return Lui_elements.keyed(partial_arg, Stdlib__Fun.id, Stdlib__String.compare, (function (user) {
      return function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___003_) {
          const partial_arg = true;
          const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(Stdlib__Fun.id, user)));
          return function (param, param$1) {
            return Lui_elements.menu_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      };
    }), param, param$1);
  };
}

function workspace(send, source) {
  const partial_arg_0 = trigger(send, source, "workspace", "Workspace menu", workspace_title);
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___004_) {
        const partial_arg = Signal.map((function (m) {
          return m.workspaces;
        }), source);
        const partial_arg_0 = identity(source);
        const partial_arg_1 = {
          hd: (function (param, param$1) {
            return Lui_elements.keyed(partial_arg, (function (w) {
              return w.id;
            }), Stdlib__String.compare, (function (param) {
              const first = Signal.sample(param);
              return function (param$1, param$2) {
                return Lui_elements.scoped((function (__lui_context___002_) {
                  const partial_arg = {
                    TAG: /* Navigate */ 0,
                    _0: {
                      TAG: /* Workspace */ 1,
                      _0: first.id
                    }
                  };
                  const partial_arg$1 = (function (param) {
                    return activate(send, partial_arg, param);
                  });
                  const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (w) {
                    return w.name;
                  }), param)));
                  return function (param, param$1) {
                    return Lui_elements.menu_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param$1, param$2);
              };
            }), param, param$1);
          }),
          tl: {
            hd: entry(send, "New workspace", {
              TAG: /* Open_workspace */ 29,
              _0: ""
            }),
            tl: {
              hd: entry(send, "Sign out", /* Logout */ 8),
              tl: /* [] */ 0
            }
          }
        };
        const partial_arg$1 = {
          hd: partial_arg_0,
          tl: partial_arg_1
        };
        const partial_arg$2 = (function (param) {
          return Lui_elements.press(send, /* Close_menu */ 15, param);
        });
        const partial_arg$3 = "below";
        const partial_arg$4 = 248;
        const partial_arg$5 = 248;
        const partial_arg$6 = function (param, param$1) {
          return Lui_elements.dropdown_menu(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, param, param$1);
        };
        const partial_arg$7 = Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
          return Caml_obj.caml_equal(m.open_menu, "workspace");
        }), source));
        return function (param, param$1) {
          return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$1 = 0;
  const partial_arg$2 = 1;
  return function (param, param$1) {
    return Lui_elements.stack(undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
}

function project_title(m) {
  const p = Stdlib__List.find_opt((function (p) {
    return Caml_obj.caml_equal(p.id, Mapre_web__Web_types.project(m.route));
  }), m.projects);
  if (p !== undefined) {
    return p.name;
  } else {
    return "Projects";
  }
}

function project_rows(m) {
  const workspace = Mapre_web__Web_types.workspace(m.route);
  if (workspace !== undefined) {
    return Stdlib__List.map((function (project) {
      return [
        workspace,
        project
      ];
    }), m.projects);
  } else {
    return /* [] */ 0;
  }
}

function project(send, source) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___007_) {
      const partial_arg_0 = trigger(send, source, "project", "Project menu", project_title);
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___008_) {
            const partial_arg = Signal.map(project_rows, source);
            const partial_arg_0 = function (param, param$1) {
              return Lui_elements.keyed(partial_arg, (function (param) {
                return [
                  param[0],
                  param[1].id
                ];
              }), Caml_obj.caml_compare, (function (param) {
                const match = Signal.sample(param);
                const first = match[1];
                const workspace = match[0];
                return function (param$1, param$2) {
                  return Lui_elements.scoped((function (__lui_context___005_) {
                    const partial_arg = {
                      TAG: /* Navigate */ 0,
                      _0: {
                        TAG: /* Project */ 2,
                        _0: workspace,
                        _1: first.id
                      }
                    };
                    const partial_arg$1 = (function (param) {
                      return activate(send, partial_arg, param);
                    });
                    const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (param) {
                      return param[1].name;
                    }), param)));
                    return function (param, param$1) {
                      return Lui_elements.menu_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param$1, param$2);
                };
              }), param, param$1);
            };
            const partial_arg$1 = {
              hd: partial_arg_0,
              tl: /* [] */ 0
            };
            const partial_arg$2 = (function (param) {
              return Lui_elements.press(send, /* Close_menu */ 15, param);
            });
            const partial_arg$3 = "below";
            const partial_arg$4 = 248;
            const partial_arg$5 = 248;
            const partial_arg$6 = function (param, param$1) {
              return Lui_elements.dropdown_menu(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, param, param$1);
            };
            const partial_arg$7 = Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (m) {
              return Caml_obj.caml_equal(m.open_menu, "project");
            }), source));
            return function (param, param$1) {
              return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
            };
          }), param, param$1);
        }),
        tl: /* [] */ 0
      };
      const partial_arg = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$1 = 0;
      const partial_arg$2 = function (param, param$1) {
        return Lui_elements.stack(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
      };
      const partial_arg$3 = Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
        return Mapre_web__Web_types.workspace(m.route) !== undefined;
      }), source));
      return function (param, param$1) {
        return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
      };
    }), param, param$1);
  };
}

export {
  workspace,
  project,
}
/* Lui_elements Not a pure module */
